import React, { useState, useMemo, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { TransitionGroup } from "react-transition-group";
import config from "config.ts";
import JumboformsSiteMap from "components/Pages/JumboformsSiteMap/index.tsx";
import Gallery from "../../Pages/Gallery/Gallery";
import Error from "../../Pages/Error/Error.js";
import SimplePage from "../../Pages/SimplePage/SimplePage";
import RouterHelper from "../../Structure/Router/RouterHelper";
import SpeedTest from "../../Pages/SpeedTest/SpeedTest";
import ContactUs from "../../Pages/ContactUs/ContactUs";
import Inbox from "../../Pages/Inbox/Inbox";
import TagManager from "react-gtm-module";
import BlogHomePage from "../../Pages/BlogHomePage/BlogHomePage";
import BlogPage from "../../Pages/BlogPage/BlogPage";
import JumboPay from "../../Pages/JumboPay/JumboPay";
import SubscribersPage from "components/Pages/Subscribers/SubscribersPage.js";
import ProfileUser from "../../Pages/ProfileUser/ProfileUser";
import Authentication from "../../Pages/AuthenticationPage/index.tsx";
import PasswordRecover from "../../Pages/PasswordRecover/PasswordRecover";
import JumboCodesRecovery from "../../Pages/JumboCodesRecovery/JumboCodesRecovery";
import EmailPreferences from "../../Pages/EmailPreferences/EmailPreferences";
import IncompletePage from "../../Pages/IncompletePage/IncompletePage";
import Uploader from "../../Pages/Uploader/Uploader";
import FormsMarketingPage from "../../Pages/FormsMarketingPage/FormsMarketingPage";
import RegistrationComplete from "../../Pages/RegistrationComplete/RegistrationComplete";
import ResetPassword from "../../Pages/ResetPassword/ResetPassword";
import UserConfirmation from "../../Pages/UserConfirmation/UserConfirmation";
import EmbedFormTemplate from "../../Reusable/EmbedFormTemplate/EmbedFormTemplate";
import Business from "../../Pages/Business/Business.tsx";
import JumboPicker from "components/Pages/JubmoPicker";
import NewEmbedPage from "../../Pages/NewEmbedPage/NewEmbedPage";
import TwitterPosts from "../../Pages/Twitter/TwitterPosts";
import OrderTrackerScript from "../../Reusable/OrderTrackerScript/OrderTrackerScript";
import Plans from "components/Pages/Plans/Plans";
import SupportPage from "components/Pages/SupportPage/SupportPage";
import EditEmbedPage from "components/Pages/EditEmbedPage/EditEmbedPage";
import CreateJumboForm from "components/Pages/CreateJumboForm/CreateJumboForm";
import Purchases from "components/Pages/Purchases_new/index.tsx";
import AccountDeleted from "components/Pages/AccountDeleted/AccountDeleted";
import CreatorHomePage from "components/Pages/JumboArt/CreatorHomePage";
import CreatorPage from "components/Pages/JumboArt/CreatorPage";
import PickerSuccessLogic from "components/Pages/Inbox/Picker/PickerSuccessLogic.tsx";
import PurchaseRetry from "components/Pages/Purchases/PurchesRetry.js";
import InviteSubUserComponent from "components/Pages/SubUsers/InviteSubUserComponent.tsx";
import FeaturesOLd from "components/Pages/Features/Features";
import AuthenticateAdminLogin from "components/Pages/AdminPages/AuthenticateAdminLogin";
import UserAuthentication from "components/Pages/AdminPages/UserAuthentication";
import ShareMailRedirectPage from "components/Pages/ShareMailRedirectPage";
import SuspendedUserError from "components/Pages/SuspendedUserError/index.tsx";

import Advertising from "components/Pages/Advertising/index.tsx";

import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import { Err404 } from "../../Pages/Error/Error404";
import { Home } from "../../Pages/Home/Home";
import { useContent } from "contexts/contentContext/contentContext";


const AboutUs = React.lazy(() => import("../../Pages/AboutUs/AboutUs"));

const radwareIcon = `${config.api.resource}/assets/icons/radware-favicon.png`;

const Router = () => {
  const location = useLocation();
  const { getLanguage, getTextByKey } = useContent();

  const [pageLocation, setPageLocation] = useState(null);

  const domainName = window.location.hostname.split(".")[1];
  const pageTitle = getTextByKey(`page-title-${domainName}`);

  useEffect(() => {
    if (checkCurrDomainIsOrgDomain()) {
      if (window.location.hostname.includes("radware")) {
        document.title = "Radware Fileshare";
      } else if (!pageTitle.includes("page-title")) {
        document.title = pageTitle;
      }
    }
  }, [pageTitle]);

  useEffect(() => {
    if (checkCurrDomainIsOrgDomain()) {
      if (window.location.hostname.includes("radware")) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = radwareIcon;
      }
    }
  }, []);

  //detecting when PAGE was changed and triggering
  useMemo(() => {
    !pageLocation ||
    (!pageLocation.includes("gallery") &&
      !pageLocation.includes("collection") &&
      pageLocation !== location.pathname) ||
    (pageLocation.includes("gallery") &&
      !location.pathname.includes("gallery")) ||
    (pageLocation.includes("collection") &&
      !location.pathname.includes("collection"))
      ? setPageLocation(location.pathname)
      : (() => null)();
  }, [location]);
  //dd

  const simplePageRoutes = [
    "terms",
    "jumbo-pay-terms",
    "privacy-policy",
    "accessibility",
    "careers",
    "user-blocked",
  ];

  const tagManagerArgs = {
    gtmId: "GTM-W9CKVK",
  };

  useMemo(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);

  const textRoute = () =>
    simplePageRoutes.map((route, i) => (
      <Route
        key={route}
        path={`/:lang/${route}`}
        element={
          <RouterHelper key={i.toString()}>
            <SimplePage />
          </RouterHelper>
        }
      />
    ));

  return (
    <TransitionGroup>
      <Routes>
        {textRoute()}
        <Route
          exact={true}
          path={`/jumboforms-pages`}
          element={<JumboformsSiteMap />}
        />
        <Route
          exact={true}
          path={`/:lang/error/:type?`}
          element={
            <RouterHelper>
              <Error />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/advertising`}
          element={
            <RouterHelper>
              <Advertising />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/gallery/:mailId/:anotherParam?/:deleteMailParams?`}
          element={
            <RouterHelper>
              <Gallery />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/j/:key/:c?/:cValue?/:u?/:uValue?/:r?/:rValue?/:sm?/:  ?/:delete?/:deleteValue?/:con?/:conValue?`}
          element={
            <RouterHelper withoutUIWrapper>
              <ShareMailRedirectPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/collection/:mailId/:anotherParam?/:deleteMailParams?`}
          element={
            <RouterHelper>
              <Gallery />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/subscribers`}
          element={
            <RouterHelper>
              <SubscribersPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/plans`}
          element={
            <RouterHelper>
              <Plans />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/jumbo-forms/:trial?`}
          element={
            <RouterHelper>
              <FormsMarketingPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/registration/:UserInvitationToken?`}
          element={
            <RouterHelper>
              <Authentication type="sign-up" />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/login`}
          element={
            <RouterHelper>
              <Authentication type="sign-in" />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/upload/:mailId?/:beta?`}
          element={
            <RouterHelper>
              <Uploader />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/for-businesses`}
          element={
            <RouterHelper>
              <Business />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path="/:lang/jumbo-picker"
          element={
            <RouterHelper>
              <JumboPicker />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/about`}
          element={
            <RouterHelper>
              <AboutUs />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/upload-speed-test`}
          element={
            <RouterHelper>
              <SpeedTest />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/password-recover`}
          element={
            <RouterHelper>
              <PasswordRecover />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/user-confirmation/:token`}
          element={
            <RouterHelper>
              <UserConfirmation />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/reset-password/:token`}
          element={
            <RouterHelper>
              <ResetPassword />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/create-form/:EmbedDynamicId?`}
          element={
            <RouterHelper>
              <CreateJumboForm />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/form/:EmbedDynamicId?`}
          element={
            <RouterHelper>
              <EmbedFormTemplate />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/order-tracker`}
          element={
            <RouterHelper>
              <OrderTrackerScript />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/page-edit/:EmbedPageUserName?/:EmbedDynamicId?`}
          element={
            <RouterHelper>
              <EditEmbedPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/page/:EmbedPageUserName?/:EmbedDynamicId?`}
          element={
            <RouterHelper>
              <NewEmbedPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/page/:EmbedPageUserName?/:EmbedDynamicId?`}
          element={
            <Navigate to={`/${getLanguage()}${window.location.pathname}`} />
          }
        />
        <Route
          exact={true}
          path={`/:lang/codes/jumbocode-recovery`}
          element={
            <RouterHelper>
              <JumboCodesRecovery />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/email-preferences/:token`}
          element={
            <RouterHelper>
              <EmailPreferences />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/jumbo-pay`}
          element={
            <RouterHelper>
              <JumboPay />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/user/:profileCategory?/:profilePage?/:dynamicformid?`}
          element={
            <RouterHelper>
              <ProfileUser />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/user/`}
          element={<Navigate to="/:lang/user/profile/account" />}
        />
        <Route
          exact={true}
          path={`/:lang/user/profile`}
          element={<Navigate to="/:lang/user/profile/account" />}
        />
        <Route
          exact={true}
          path={`/:lang/user/:profileCategory?/:profilePage?/:dynamicformid?`}
          element={
            <RouterHelper>
              <ProfileUser />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/contact-us`}
          element={
            <RouterHelper>
              <ContactUs />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/registration-complete/incomplete`}
          element={
            <RouterHelper>
              <IncompletePage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/registration-complete`}
          element={
            <RouterHelper>
              <RegistrationComplete />
            </RouterHelper>
          }
        />
        {/* <Route
        path={`/:lang/support/:supportCategory?/:supportQuestion?`}
        element={
          <RouterHelper>
            <SimplePage>
              <Support />
            </SimplePage>
          </RouterHelper>
        }
      /> */}
        <Route
          path={`/:lang/support/:isQuestion?/:supportQuestion?/:subsubid?`}
          element={
            <RouterHelper>
              <SupportPage />
            </RouterHelper>
          }
        />
        <Route
          path={`/:lang/features/:featuresPage?`}
          element={
            <RouterHelper support>
              <FeaturesOLd />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/blog`}
          element={
            <RouterHelper>
              <BlogHomePage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/blog/:blogArticle`}
          element={
            <RouterHelper>
              <BlogPage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/inbox/:anotherParam?`}
          element={
            <RouterHelper>
              <Inbox />
            </RouterHelper>
          }
        />
        {/* page for iframe redirect when picker project saved */}
        <Route
          exact={true}
          path={`/:lang/picker-success`}
          element={
            // <RouterHelper>
            <PickerSuccessLogic />
            // </RouterHelper>
          }
        />
        <Route
          exact={true}
          path="/:lang/home/:anotherParam?/:uploadId?"
          element={
            <RouterHelper>
              <Home />
            </RouterHelper>
          }
        />
        <Route
          path={`/:lang/news`}
          element={
            <RouterHelper>
              <SimplePage>
                <TwitterPosts />
              </SimplePage>
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/sub-user-complete/:token`}
          element={
            <RouterHelper>
              <InviteSubUserComponent pageType="subuser" />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/stage`}
          element={
            <RouterHelper>
              <CreatorHomePage />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/stage/:creatorUrl?`}
          element={
            <RouterHelper>
              <CreatorPage />
            </RouterHelper>
          }
        />
        <Route
          path={`/:lang/purchase/:packageType/:periodType?/:coupon?/:couponCode?`}
          element={
            <RouterHelper>
              <Purchases />
            </RouterHelper>
          }
        />
        {/* <Route
          path={`/:lang/purchase-result`}
          element={
            <RouterHelper>
              <PurchaseResult />
            </RouterHelper>
          }
        /> */}
        <Route
          exact={true}
          path={`/:lang/invite/:token`}
          element={
            <RouterHelper>
              <InviteSubUserComponent pageType="invite" />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/account-deleted/:token`}
          element={
            <RouterHelper>
              <AccountDeleted />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/purchase-error-retry`}
          element={
            <RouterHelper>
              <PurchaseRetry />
            </RouterHelper>
          }
        />
        <Route
          exact={true}
          path={`/:lang/authenticate-login`}
          element={<AuthenticateAdminLogin />}
        />
        <Route
          exact={true}
          path={`/:lang/authenticate-user`}
          element={<UserAuthentication />}
        />
        <Route
          exact={true}
          path={`/:lang/suspended-user`}
          element={
            <RouterHelper>
              <SuspendedUserError />
            </RouterHelper>
          }
        />
        <Route
          path="*"
          element={
            <RouterHelper>
              <Err404 />
            </RouterHelper>
          }
        />
        {/* {navigator.userAgent !== "ReactSnap" && (
            <Route path={`*`} element={() => <RedirectComponent />} />
          )} */}
      </Routes>
    </TransitionGroup>
  );
};

export default Router;
